import Vue from 'vue' 
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';

import VTooltip from 'v-tooltip'  
import store from '@/state/store'
import App from './App.vue' 
import { initFirebaseBackend } from './authUtils'
import i18n from '@/helpers/i18n'
import { configureFakeBackend } from './helpers/fake-backend';
import tinymce from 'vue-tinymce-editor'
import axios from 'axios'
import { BootstrapVue, IconsPlugin,ToastPlugin } from 'bootstrap-vue' 
import { BToast } from 'bootstrap-vue'
import VSwitch from 'v-switch-case' 
import VueExcelEditor from 'vue-excel-editor'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";  
import "../src/design/app.scss";
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import VueCryptojs from 'vue-cryptojs'
import JsonExcel from 'vue-json-excel' 
 
 
fetch(window.location.protocol+"//"+window.location.host+"/assets/config.json")
.then(response => response.json())
.then(config => { 

Vue.prototype.$config = config    
axios.defaults.baseURL = config.API_URL 
axios.defaults.headers.common = { 'Authorization': 'Bearer '+store.getters.["auth/JWToken"] }
 
 
var VueCookie = require('vue-cookie'); 
Vue.use(VueCookie);
Vue.use(VueCookies)
Vue.use(VueCryptojs)
Vue.use(VTooltip)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)
Vue.component('b-toast', BToast)
Vue.use(VueClipboard)
Vue.component('downloadExcel', JsonExcel)

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});
 

Vue.use(VueExcelEditor)

Vue.use(VSwitch)
const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)

Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

//Vue.use(BootstrapVue)

Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
 
}) 